<template>
    <header class="sticky top-0 z-50" :class="show && !isMobileBreakpoint ? 'show-toast' : ''" ref="navRef">
        <AnnouncementBanner v-if="showAnnouncementBanner"/>
        <NavBar />
    </header>
</template>
 
<script setup lang="ts">
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'
import AnnouncementBanner from './ui/atom/announcementBanner.vue'
import NavBar from './ui/organism/navBar.vue'
import { useAddToCartToastStore } from '~/stores/addToCartToastStore'

const toastStore = useAddToCartToastStore()
const { show } = storeToRefs(toastStore)
const showAnnouncementBanner = ref(true);
const breakPoints = useBreakpoints(breakpointsTailwind);
const isMobileBreakpoint = breakPoints.smaller('md');

const uiStore = useUIStore();
const { navRef } = storeToRefs(uiStore);

defineExpose({
    showAnnouncementBanner
});

 
</script>
 
<style>
.show-toast {
    z-index: 99999 !important;
}
</style>

